import React from "react";

function ContactPage() {
  const [submitted, setSubmitted] = React.useState(false);

  return (
    <main className="contact-page">

      <section className="section contact-main">
        <div className="container contact-layout">
          <aside className="contact-sidebar">
            <h2 className="eyebrow">Let&apos;s Talk</h2>
            <p className="contact-intro">
              Have a question or planning your next investment? Our team is here
              to guide you every step of the way.
            </p>
            <div className="contact-details">
              <p>
                <span>Email</span>
                <br />
                info@Dhanvanti.com
              </p>
              <p>
                <span>Contact</span>
                <br />
                +91 73985 73985
              </p>
            </div>
            <div className="contact-socials">
              <span>Socials</span>
              <a href="https://www.facebook.com/profile.php?id=61559684253885&mibextid=wwXIfr&rdid=DOMTHVSdYsedvsj8&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F18HJQUS2zL%2F%3Fmibextid%3DwwXIfr#" target="_blank"
                rel="noopener noreferrer">LinkedIn</a>
              <a href="https://www.instagram.com/dhanvantiluxurybuilders?igsh=MjdodTk1NDdoMmtk" target="_blank"
                rel="noopener noreferrer">Instagram</a>
              <a href="https://www.linkedin.com/company/dhanvantiluxurybuilders" target="_blank"
                rel="noopener noreferrer">Facebook</a>
            </div>
          </aside>

          <div className="contact-card">
            {!submitted ? (
              <>
                <h3>Book a Site Visit Now</h3>
                <p className="contact-subtitle">Fill in the form.</p>
                <form
                  className="contact-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    setSubmitted(true);
                  }}
                >
                  <div className="form-row">
                    <div className="form-field">
                      <input type="text" placeholder="First name" required />
                    </div>
                    <div className="form-field">
                      <input type="text" placeholder="Last name" required />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-field">
                      <input type="email" placeholder="Email address" required />
                    </div>
                    <div className="form-field">
                      <input type="tel" placeholder="Phone" required />
                    </div>
                  </div>
                  <div className="form-field">
                    <textarea
                      rows="3"
                      placeholder="Share any details you would like us to know."
                    />
                  </div>
                  <div className="form-actions">
                    <button type="submit" className="btn-primary">
                      Request to call back
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <div className="contact-success">
                <div className="success-icon">
                  <span>✓</span>
                </div>
                <h3>Thank You</h3>
                <p>Our team will get back to you soon.</p>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => setSubmitted(false)}
                >
                  Submit another enquiry
                </button>
              </div>
            )}
          </div>
        </div>
      </section>
    </main>
  );
}

export default ContactPage;

